import React from 'react';
import { useMediaSize } from '@ally/metronome-ui';
import MenuLink from './MenuLink';
import { StyledMenuItem } from './StyledMenuComponents';
export default function NoAccountsMenu({ bankStatus, hasNoAccounts, isBank, isBankOperational, bankMessageCount, routeInEmber, routeLinks, closeMenu, }) {
    const isBankDown = bankStatus === 'down';
    const isLgUp = useMediaSize('LgUp');
    const shouldRender = isLgUp && isBank && hasNoAccounts && isBankOperational && !isBankDown;
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.statements.bankUrl, text: routeLinks.statements.content, routeInEmber: routeInEmber, closeMenu: closeMenu })),
        React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.secureMessages.bankUrl, text: `${routeLinks.secureMessages.content} ${bankMessageCount > 0 ? `(${bankMessageCount})` : ''}`, routeInEmber: routeInEmber, closeMenu: closeMenu }))));
}
//# sourceMappingURL=NoAccountsMenu.js.map